var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simplebar',{ref:"simplebar",staticClass:"home",attrs:{"data-simplebar-auto-hide":"false","data-simplebar-click-on-track":"false"}},[_c('div',{attrs:{"id":"frame-container"}},[_c('div',{attrs:{"id":"betgames_div_iframe"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }